<template>
  <div class="content-container">
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">
                {{ $t('views.report.houseKeepingMustCheckReport') }}
              </span>
            </div>
            <div class="flex" style="gap: 10px">
              <InfoBtn @click="noteDialogVisible = true" />
              <el-dropdown trigger="click" @command="onClickDropdownItem">
                <das-button
                  color="primary"
                  size="medium"
                  :rounded="false"
                  outline
                  icon
                >
                  <i class="el-icon-download"></i>
                </das-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">
                    {{ $t('button.exportPdf') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="excel">
                    {{ $t('button.exportExcel') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <hr />
          <div class="w-full">
            <el-table
              class="report-table overflow-auto"
              :height="'700px'"
              :data="rows"
              :border="true"
              :span-method="objectSpanMethod"
            >
              <!-- :span-method="objectSpanMethod" -->
              <el-table-column
                v-for="(item, index) in columns"
                :key="index"
                :prop="item.field"
                :label="item.headerName"
                :min-width="item?.minWidth || 100"
                :header-align="'left'"
                :align="item.cellClass === 'ag-cell-right' ? 'right' : null"
              >
                <!-- :formatter="
                  formatNumberField.includes(item.field) ? displayNumber : null
                " -->
              </el-table-column>
            </el-table>
          </div>
          <!-- <div v-loading="gridLoading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              dom-layout="scroll"
              :rows="rows"
              class="agGrid"
              :auto-size-cell="true"
            />
          </div> -->
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('dialog.titleNote')"
      :visible.sync="noteDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="note-container">
            <ul>
              <li>
                Trạng thái:
                <ul>
                  <li>Đến: Phòng có booking đến</li>
                  <li>Đi: Phòng có booking đi</li>
                </ul>
              </li>
              <li>Số phòng: Hiển thị số phòng</li>
              <li>Hạng phòng: Hiện thị hạng phòng của phòng</li>
              <li>Trạng thái phòng: Hiển thị trạng thái phòng Clean</li>
              <li>
                Giờ đến: Giờ nhân viên buồng phòng đến phòng cần kiểm tra.
                Format:HH:MM:SS
              </li>
              <li>
                Giờ đi: Giờ nhân viên buồng phòng rời phòng cần kiểm tra.
                Format: HH:MM:SS
              </li>
              <li>Thay đổi trạng thái:</li>
              <li>Nhân viên: Nhân viên buồng phòng</li>
              <li>
                Dịch vụ đặc biệt: Hiển thị số lượng, mã dịch vụ đặc biệt phòng
                sử dụng
              </li>
              <li>Ghi chú: ghi chú phòng</li>
            </ul>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="noteDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DasButton from '@/components/ui/DasButton.vue'
import InfoBtn from './components/InfoBtn.vue'
import {
  getHouseKeepingMustCheckReportApi,
  getHouseKeepingMustCheckReportApiExcel
} from '@/api/report_service/report'
import { downFile } from '@/utils/file-handler'

export default {
  components: {
    DasButton,
    InfoBtn
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        autoHeight: true,
        wrapText: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      noteDialogVisible: false,
      gridLoading: false,
      roomStatusOptions: [
        {
          id: 1,
          label: 'Vacant Clean'
        },
        {
          id: 2,
          label: 'Vacant Dirty'
        },
        {
          id: 3,
          label: 'Vacant Ready'
        },
        {
          id: 4,
          label: 'Occupied Clean'
        },
        {
          id: 5,
          label: 'Occupied Dirty'
        }
      ],
      // hotelOptions: [],
      columns: [
        {
          headerName: this.$t('grid.column.status'),
          field: 'status',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.roomNo'),
          field: 'roomNum',
          // cellClass: "grid-cell-centered",
          // width: 100,
          // flex: 1,
          sortable: false,
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'roomLevel',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 150
        },
        {
          headerName: this.$t('grid.column.roomState'),
          field: 'roomStatus',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 150
        },
        {
          headerName: this.$t('grid.column.arriveTime'),
          field: 'unlockTime',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 120
        },

        {
          headerName: this.$t('grid.column.modifyState'),
          field: 'changeStatus',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 150
        },
        {
          headerName: 'Thời gian thay đổi trạng thái',
          field: 'changeStatusTime',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 150
        },
        {
          headerName: 'Nhân viên thực hiện',
          field: 'staff',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 200
        },

        {
          headerName: this.$t('grid.column.note'),
          field: 'note',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 200
        }
      ],
      rows: [
        // {
        //   col1: 'Đến',
        //   col2: '103',
        //   col3: 'SUP',
        //   col4: 'Vacant dirty',
        //   col5: '12:11:12',
        //   col6: '12:30:12',
        //   col7: 'Vacant ready',
        //   col8: 'Anh Nguyễn Văn A',
        //   col9: 'music speaker',
        //   col10: 'Kiểm tra kĩ'
        // }
      ]
    }
  },
  mounted() {
    // this.getHotelOptions()
    this.attachData()
  },
  methods: {
    displayNumber(row, column, cellValue) {
      // console.log('rowwww2,', row, cellValue)
      return this.$displayCurrency(cellValue)
    },
    objectSpanMethod(data) {
      // 0 1 2 7 8
      if (data.columnIndex <= 2 || data.columnIndex >= 7) {
        if (data.row.rowSpan !== undefined) {
          return {
            rowspan: data.row.rowSpan,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    // SELECT OPTIONS
    // getHotelOptions() {
    //   getAllHotel().then(res => {
    //     this.hotelOptions = res.data
    //   })
    // },

    // onSearch() {},
    // onReset() {},
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    onClickDropdownItem(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    attachData() {
      this.gridLoading = true
      getHouseKeepingMustCheckReportApi()
        .then(res => {
          // this.rows = res.data
          var data = res.data
          this.rows = data.flatMap((item, index) => {
            return item.timeToTimeList.map((item1, index1) => {
              if (index1 === 0) {
                return {
                  ...item1,
                  ...item,
                  rowSpan: item.timeToTimeList.length
                }
              } else {
                return {
                  ...item1,
                  ...item
                }
              }
            })
          })
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading = false
        })
    },
    downloadExcel() {
      this.gridLoading = true
      getHouseKeepingMustCheckReportApiExcel()
        .then(res => {
          const date = this.$moment().format('DD-MM-YYYY')
          downFile(res, 'bao_cao_buong_phong_can_kiem_tra_' + date + '.xlsx')
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading = false
        })
    }
  }
}
</script>

<style></style>
